import { BASE_URL, fetchWithAuth } from "./client";

const MESSAGING_API_BASE_URL = (
  process.env.REACT_APP_MESSAGING_API ||
  process.env.REACT_APP_API_BASE ||
  BASE_URL ||
  ""
).replace(/\/+$/, "");

const getErrorMessage = async (response, fallback) => {
  const error = await response.json().catch(() => ({}));
  const detail = error.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) return detail.message;
  if (detail?.error) return detail.error;
  return error.error || error.message || fallback;
};

export const createMessengerBotConfig = async (data) => {
  const response = await fetchWithAuth(`${MESSAGING_API_BASE_URL}/api/messenger-bot/configs`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(await getErrorMessage(response, "Failed to create Messenger config"));
  }

  const result = await response.json();
  return result.data || result;
};

export const getMessengerBotConfigs = async (platform = "") => {
  const params = new URLSearchParams();
  if (platform) {
    params.set("platform", platform);
  }
  const query = params.toString();
  const response = await fetchWithAuth(`${MESSAGING_API_BASE_URL}/api/messenger-bot/configs${query ? `?${query}` : ""}`);

  if (!response.ok) {
    throw new Error(await getErrorMessage(response, "Failed to load messaging configs"));
  }

  const result = await response.json();
  return result.data || result;
};

export const getMessengerBotConfig = async (configId) => {
  const response = await fetchWithAuth(`${MESSAGING_API_BASE_URL}/api/messenger-bot/configs/${configId}`);

  if (!response.ok) {
    throw new Error(await getErrorMessage(response, "Failed to load Messenger config"));
  }

  const result = await response.json();
  return result.data || result;
};

export const updateMessengerBotConfig = async (configId, data) => {
  const response = await fetchWithAuth(`${MESSAGING_API_BASE_URL}/api/messenger-bot/configs/${configId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(await getErrorMessage(response, "Failed to update Messenger config"));
  }

  const result = await response.json();
  return result.data || result;
};

export const deleteMessengerBotConfig = async (configId) => {
  const response = await fetchWithAuth(`${MESSAGING_API_BASE_URL}/api/messenger-bot/configs/${configId}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error(await getErrorMessage(response, "Failed to delete Messenger config"));
  }

  const result = await response.json();
  return result.data || result;
};

export const sendMessengerBotTest = async (configId, message) => {
  const response = await fetchWithAuth(`${MESSAGING_API_BASE_URL}/api/messenger-bot/configs/${configId}/test`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message }),
  });

  if (!response.ok) {
    throw new Error(await getErrorMessage(response, "Failed to send test message"));
  }

  const result = await response.json();
  return result.data || result;
};
